export default __webpack_public_path__ + "static/media/svelte.7b116dd5.svg";